import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText, BodyText, Link, RefreshIcon } from '@paypalcorp/pp-react';
import styles from './givingSummaryError.less';

const GivingSummaryError = ({ heading, message, retryMessage, onRetry }) => {
  return (
    <div className={styles.alertSection}>
      <RefreshIcon size='xl' />
      <HeadingText className={styles.heading} size='sm'>
        {heading}
      </HeadingText>
      <BodyText className={styles.message}>{message}</BodyText>
      <div className={styles.fullWidthButton}>
        <Link href='#' className={styles.retryLink} onClick={(e) => onRetry(e)}>
          {retryMessage}
        </Link>
      </div>
    </div>
  );
};

GivingSummaryError.propTypes = {
  heading: PropTypes.string,
  message: PropTypes.string,
  retryMessage: PropTypes.string,
  onRetry: PropTypes.func,
};

export default GivingSummaryError;
